import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NotificationTypeGroup = React.lazy(() =>
    import('../NotificationTypeGroup')
);
const notificationTypeGroupRoutesRegistry = [
    {
        path: PAGE_URL.NOTIFICATION_TYPE_GROUP_PAGE,
        element: <NotificationTypeGroup />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default notificationTypeGroupRoutesRegistry;
